module.exports = __webpack_public_path__ + "static/client-3-6641da62f4692859e718097864345172.jpg";